import { LanguageType } from "../../types";

const supportedLanguages = ["ko", "zh-HK", "zh-TW", "ja"] as const;

export default function toLanguageType(value: string): LanguageType | null {
  const normalized = value.toLowerCase();

  return (
    supportedLanguages.find((lang) => lang.toLowerCase() === normalized) ?? null
  );
}
